{
  "games": [
    {
      "id": "2023-01-17:1",
      "date": {
        "year": 2023,
        "month": 1,
        "day": 17
      },
      "ball": "H10",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 89,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 107,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 115,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 115,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-01-26:1",
      "date": {
        "year": 2023,
        "month": 1,
        "day": 26
      },
      "ball": "H10",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 26,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 33,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 59,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 59,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 62,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 71,
      "pins": 64,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2023-02-02:1",
      "date": {
        "year": 2023,
        "month": 2,
        "day": 2
      },
      "ball": "H10",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 12,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 19,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 27,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 39,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 54,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 70,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            7
          ],
          "cumulative": 87,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 87,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-02-09:1",
      "date": {
        "year": 2023,
        "month": 2,
        "day": 9
      },
      "ball": "H10",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 78,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 97,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 106,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 126,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            "-"
          ],
          "cumulative": 136,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 136,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-02-16:1",
      "date": {
        "year": 2023,
        "month": 2,
        "day": 16
      },
      "ball": "H10",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 23,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 32,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 61,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 80,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 118,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X",
            9,
            "/"
          ],
          "cumulative": 138,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 138,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-02-27:1",
      "date": {
        "year": 2023,
        "month": 2,
        "day": 27
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 17,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 23,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 29,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 48,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 72,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 89,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First game with 12lbs ball",
      "score": 97,
      "pins": 74,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-02:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 2
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 37,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 44,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 70,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 89,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 115,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 122,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 122,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-02:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 2
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 37,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 55,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 63,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 83,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 101,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 109,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 115,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 122,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 125,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 125,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-04:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 4
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 9,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 56,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 74,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 90,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Slight leg pain",
      "score": 90,
      "pins": 75,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-04:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 4
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 13,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 21,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 29,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 44,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 51,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 60,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 68,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            4
          ],
          "cumulative": 82,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Slight leg pain",
      "score": 82,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-06:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 6
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            1
          ],
          "cumulative": 2,
          "score": 2,
          "pins": 2,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 9,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 37,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 42,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 49,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 79,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 87,
      "pins": 72,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-06:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 6
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 10,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 17,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 33,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 39,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 76,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            1
          ],
          "cumulative": 78,
          "score": 2,
          "pins": 2,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First try to hook",
      "score": 78,
      "pins": 62,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-06:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 6
      },
      "ball": "H12",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 3,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 6,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 13,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 19,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            2,
            6
          ],
          "cumulative": 27,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 28,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 34,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 34,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/",
            "-"
          ],
          "cumulative": 51,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Second try to hook",
      "score": 51,
      "pins": 51,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 1.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 10,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-08:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 8
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 16,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 21,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 26,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 44,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 58,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First training, perfect ball weight, layout too large",
      "score": 75,
      "pins": 67,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 9,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-08:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 8
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 43,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 51,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 84,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 94,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First training, perfect ball weight, layout too large",
      "score": 94,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-08:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 8
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 46,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 53,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 61,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 69,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 77,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 86,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 93,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 101,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First training, perfect ball weight, layout too large",
      "score": 101,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-12:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 12
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 19,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 34,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 39,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 65,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 72,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            1
          ],
          "cumulative": 85,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 92,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Perfect ball weight (house ball), layout too large",
      "score": 92,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-12:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 12
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 15,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 23,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 37,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 41,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 42,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 48,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 51,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 60,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            9
          ],
          "cumulative": 79,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Perfect ball weight (house ball), layout too large",
      "score": 79,
      "pins": 75,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-12:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 12
      },
      "ball": "H14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 37,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 56,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 63,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 79,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 86,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/",
            6
          ],
          "cumulative": 102,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Perfect ball weight (house ball), layout too large",
      "score": 102,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-15:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 15
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 33,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 51,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 74,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 81,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            9,
            "-"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "Ball slightly light (house ball), good layout",
      "score": 109,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-15:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 15
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 39,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 40,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 57,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 64,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 79,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 84,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Ball slightly light (house ball), good layout",
      "score": 84,
      "pins": 72,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-15:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 15
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 18,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            2
          ],
          "cumulative": 23,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 30,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 33,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 53,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 71,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Ball slightly light (house ball), good layout",
      "score": 88,
      "pins": 70,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-15:4",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 15
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 10,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 19,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 24,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 43,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 61,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 66,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Ball slightly light (house ball), good layout",
      "score": 94,
      "pins": 76,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-18:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 18
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            1
          ],
          "cumulative": 10,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 17,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 48,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 63,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 71,
      "pins": 71,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-18:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 18
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 35,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 55,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 68,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 71,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 78,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 95,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 102,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 111,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 120,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-18:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 18
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 13,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 30,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 37,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 43,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 59,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 65,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 79,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 83,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/",
            6
          ],
          "cumulative": 99,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 99,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-18:4",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 18
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 14,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 32,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 57,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 82,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 89,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 105,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-20:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 20
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 15,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 33,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 60,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 79,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 107,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 116,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 116,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-20:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 20
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 48,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 56,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 63,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 112,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 131,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 140,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 140,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-22:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 22
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 23,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 40,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 103,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-22:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 22
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 41,
          "score": 25,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 61,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 77,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 113,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 122,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 125,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 125,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-22:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 22
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 21,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 24,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 28,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            7,
            1
          ],
          "cumulative": 81,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 81,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-22:4",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 22
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 22,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 29,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 57,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 79,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 99,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 115,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 124,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 124,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-22:5",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 22
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 13,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 29,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 35,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 42,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 54,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 55,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 67,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 67,
      "pins": 60,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-24:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 24
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 38,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 75,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 103,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 112,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 121,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 121,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-24:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 24
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 34,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 40,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 84,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 101,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 110,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 110,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-24:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 24
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 23,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 30,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 39,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 45,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 52,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 59,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 62,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 69,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Out of focus, loudy players on next lane (need to focus on my focus)",
      "score": 69,
      "pins": 69,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-24:4",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 24
      },
      "ball": "H13",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 9,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 28,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 82,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 89,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:1",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 15,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 16,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 49,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 64,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            "X"
          ],
          "cumulative": 84,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "First games with new balls",
      "score": 84,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:2",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 38,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 45,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 62,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 70,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 91,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            "X"
          ],
          "cumulative": 111,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "First games with new balls",
      "score": 111,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:3",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 21,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 27,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 43,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 88,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 106,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 115,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games with new balls",
      "score": 115,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:4",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 18,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 31,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 40,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 76,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 83,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games with new balls",
      "score": 83,
      "pins": 74,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:5",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 14,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 23,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 42,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 67,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 74,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games with new balls",
      "score": 99,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-03-29:6",
      "date": {
        "year": 2023,
        "month": 3,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 88,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 95,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games with new balls",
      "score": 104,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 15,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 28,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 46,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 49,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 65,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 72,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 81,
      "pins": 78,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 25,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 81,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 86,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 93,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 111,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 119,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 119,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 80,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 87,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 111,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            7,
            "/"
          ],
          "cumulative": 140,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 140,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            1
          ],
          "cumulative": 2,
          "score": 2,
          "pins": 2,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 24,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 40,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 46,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 53,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 84,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 93,
      "pins": 76,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 27,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 63,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 82,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 91,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 95,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 103,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 111,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 111,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 44,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 89,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 106,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 114,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 123,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 142,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 142,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:7",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 13,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 21,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 40,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 59,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 65,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 82,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 98,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-01:8",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 44,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 70,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 97,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/",
            4
          ],
          "cumulative": 119,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Long series of games in crowded lines",
      "score": 119,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 42,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 49,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 57,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 12,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            2,
            4
          ],
          "cumulative": 84,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 84,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 27,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 61,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 68,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 76,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 96,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "/",
            6
          ],
          "cumulative": 112,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 112,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 34,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 40,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 87,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 94,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 102,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 19,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 25,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 41,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 47,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 64,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 73,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 81,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 86,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 86,
      "pins": 73,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 48,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 88,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 107,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 116,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            8
          ],
          "cumulative": 134,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 134,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-05:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 3,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 11,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 24,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 27,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 27,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 64,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 76,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 79,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 79,
      "pins": 59,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 24,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 43,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 57,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 63,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 69,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 87,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 97,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 106,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 113,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 113,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 19,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 26,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 75,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 89,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 93,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 112,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 112,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            4
          ],
          "cumulative": 32,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 45,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 73,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 91,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 95,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 95,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 38,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 46,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 55,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 75,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 93,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 101,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 110,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 119,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 119,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 32,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 53,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 60,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 79,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            3
          ],
          "cumulative": 109,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 109,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-12:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 32,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 56,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 76,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 95,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 123,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 132,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 140,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 140,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 15,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 23,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 29,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 36,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 64,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 80,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 86,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 103,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 103,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 36,
          "score": 16,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 42,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 84,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 90,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            4
          ],
          "cumulative": 104,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First converted split!",
      "score": 104,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 3,
          "converted": 1
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 25,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 53,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 69,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 82,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 88,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            1
          ],
          "cumulative": 115,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 115,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 49,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 91,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 97,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 112,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 118,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 119,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "It started so well… then I panicked.",
      "score": 119,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 69,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 89,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 127,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 144,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 151,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 151,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 5,
          "single": 3,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-15:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 15
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 14,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 34,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 51,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 95,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            4
          ],
          "cumulative": 118,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 118,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 14,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 23,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 32,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 48,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 68,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 87,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 104,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 104,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 29,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 55,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 72,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 84,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            3,
            2
          ],
          "cumulative": 99,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 99,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 55,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 75,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 94,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 106,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 106,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 40,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 43,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 51,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 67,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 84,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 101,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            9,
            "/"
          ],
          "cumulative": 121,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 121,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 27,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 56,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 96,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 115,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 124,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 132,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 139,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            3
          ],
          "cumulative": 143,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 143,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-19:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 36,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 49,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 57,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 80,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 97,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            "-"
          ],
          "cumulative": 107,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 107,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 25,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 34,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 34,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 34,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 67,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Worst oil condition ever. Wasn't able to figure how to properly hook. Still a lot to learn…",
      "score": 76,
      "pins": 59,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 9,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 15,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 22,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 31,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 40,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 71,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            "X",
            1
          ],
          "cumulative": 109,
          "score": 21,
          "pins": 21,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 109,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 31,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 39,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 52,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 55,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 92,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 111,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 120,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 37,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 57,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 74,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 90,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 106,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 117,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 126,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 134,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 13,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 22,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 30,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 37,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 63,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 79,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 88,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 52,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 61,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 70,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 103,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            1
          ],
          "cumulative": 114,
          "score": 11,
          "pins": 11,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 114,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-22:7",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 22
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 22,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 25,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 57,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 64,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 71,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 78,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "The \"I should have stopped before\". I need to listen to my body.",
      "score": 78,
      "pins": 75,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:1",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 40,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 97,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 117,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 134,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 134,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:2",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 55,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 73,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 105,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/",
            9
          ],
          "cumulative": 124,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 124,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:3",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 33,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 59,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 67,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            5
          ],
          "cumulative": 119,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 119,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:4",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 37,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 93,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 102,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 118,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 126,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 134,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:5",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 80,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 96,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-04-26:6",
      "date": {
        "year": 2023,
        "month": 4,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 55,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 73,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 97,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 113,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            8
          ],
          "cumulative": 131,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 131,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            1
          ],
          "cumulative": 30,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 45,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 73,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 88,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/",
            1
          ],
          "cumulative": 99,
          "score": 11,
          "pins": 11,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Bad oil (nearly dry lane) condition. Time to train position and form.",
      "score": 99,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 53,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 59,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 105,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 113,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/",
            7
          ],
          "cumulative": 130,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Bad oil (nearly dry lane) condition. Time to train position and form.",
      "score": 130,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 21,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 24,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 41,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 48,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 85,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Played only straight, with spare ball.",
      "score": 102,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Played only straight, with spare ball.",
      "score": 94,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 34,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 47,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 66,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 102,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 119,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 132,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/",
            5
          ],
          "cumulative": 147,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Very proud of my closing, here. :)",
      "score": 147,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 8,
          "single": 2,
          "multiple": 6
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-01:6",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 1
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 30,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 33,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 48,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 55,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 64,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 89,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            6
          ],
          "cumulative": 105,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Slight pain at the end.",
      "score": 105,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 0,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 28,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 89,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            4
          ],
          "cumulative": 103,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 103,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 19,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 46,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 54,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 60,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 67,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 74,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.",
      "score": 83,
      "pins": 75,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            2
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 13,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 21,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 29,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 38,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 55,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 64,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 80,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            7
          ],
          "cumulative": 97,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.",
      "score": 97,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 23,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 39,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 45,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 64,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 73,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 78,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 98,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 118,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 135,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            "-"
          ],
          "cumulative": 145,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.",
      "score": 145,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 32,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 44,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 47,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 55,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 63,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 78,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.",
      "score": 78,
      "pins": 70,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:6",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 43,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 61,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 69,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 76,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 79,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 85,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.",
      "score": 94,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-03:7",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 3
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 45,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 83,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 102,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 111,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            9
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 130,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 24,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 40,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 47,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 47,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 50,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 75,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 75,
      "pins": 70,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 9,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 33,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 66,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 72,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 81,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 46,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 79,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 86,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            3
          ],
          "cumulative": 108,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 108,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 57,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 60,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 79,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 89,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 96,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 96,
      "pins": 73,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 24,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 41,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 67,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 76,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 83,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 99,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            7
          ],
          "cumulative": 116,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 116,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 5,
          "single": 0,
          "multiple": 5
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-07:6",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 7
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 81,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 89,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 96,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 125,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            3
          ],
          "cumulative": 138,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 138,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-10:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 10
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 10,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 17,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 17,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 20,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 29,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 38,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 41,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 49,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            "X",
            9
          ],
          "cumulative": 78,
          "score": 29,
          "pins": 29,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "Really casual games, on kids' day, with the son. Not really focused.",
      "score": 78,
      "pins": 78,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-10:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 10
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 49,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 67,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 102,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, on kids' day, with the son. Not really focused.",
      "score": 102,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-10:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 10
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 21,
          "score": 15,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 26,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 43,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 61,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 79,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 91,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, on kids' day, with the son. Not really focused.",
      "score": 91,
      "pins": 78,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-10:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 10
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 31,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 57,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 85,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 111,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 119,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, on kids' day, with the son. Not really focused.",
      "score": 119,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-10:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 10
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 15,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 33,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 70,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 83,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 86,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            2,
            6
          ],
          "cumulative": 94,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, on kids' day, with the son. Not really focused.",
      "score": 103,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 12,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 18,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 42,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 87,
      "pins": 78,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 14,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            1
          ],
          "cumulative": 18,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 37,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 81,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 94,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 112,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 121,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 129,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "First usage of a \"grip glove\" I bought",
      "score": 129,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 32,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 43,
          "score": 11,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 71,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 94,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "First usage of a \"grip glove\" I bought",
      "score": 102,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 3,
          "converted": 1
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 35,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 72,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 100,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            8
          ],
          "cumulative": 127,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "First usage of a \"grip glove\" I bought",
      "score": 127,
      "pins": 100,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 63,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 91,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 100,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First usage of a \"grip glove\" I bought",
      "score": 118,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-17:6",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 40,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 66,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First usage of a \"grip glove\" I bought",
      "score": 102,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-21:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 14,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 15,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 24,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 69,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 77,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 85,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-21:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 28,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 51,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 84,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 100,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 106,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 115,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 115,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-21:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 15,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 32,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            2
          ],
          "cumulative": 54,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 67,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 70,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 89,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            "X"
          ],
          "cumulative": 109,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 109,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-21:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 25,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 62,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 82,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 101,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 110,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 118,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-21:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 43,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 63,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 86,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 112,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 132,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 161,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            9,
            "/"
          ],
          "cumulative": 181,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 181,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 5,
          "single": 3,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 34,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 51,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 71,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 106,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            7,
            "-"
          ],
          "cumulative": 123,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 123,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 13,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 16,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 43,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 71,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 89,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 98,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:3",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 14,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 31,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 38,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 53,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 60,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 67,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 86,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            6
          ],
          "cumulative": 111,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 111,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:4",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 24,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 30,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 33,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 69,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 77,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 86,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 94,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 94,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:5",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 33,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 36,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 60,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 66,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 104,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 113,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 121,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 121,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:6",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 48,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 99,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 107,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 116,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 125,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 134,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-24:7",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 55,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 63,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 91,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 100,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 117,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 117,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-28:1",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 28
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 15,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 34,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 43,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 76,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 95,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 118,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 124,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 124,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-05-28:2",
      "date": {
        "year": 2023,
        "month": 5,
        "day": 28
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 12,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 19,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 43,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 48,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 83,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            "X"
          ],
          "cumulative": 103,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 103,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:1",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 57,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 67,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 73,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 90,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 97,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 98,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 98,
      "pins": 76,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:2",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 42,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 66,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 84,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 91,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 110,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 110,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:3",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 23,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 30,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 34,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 42,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 79,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 97,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:4",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 25,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 44,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 85,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 92,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 100,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:5",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 96,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 115,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 124,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 133,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 141,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 141,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:6",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 36,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 42,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 62,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 90,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 127,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 136,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 145,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 145,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-14:7",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 34,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 76,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 93,
          "score": 17,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 109,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 116,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 116,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:1",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 17,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 22,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 29,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 36,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            "-"
          ],
          "cumulative": 81,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 81,
      "pins": 73,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:2",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 11,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 18,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 23,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 26,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 33,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 58,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 77,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 86,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 86,
      "pins": 71,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:3",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 21,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 27,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 43,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 51,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 65,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 93,
      "pins": 78,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:4",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 50,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 80,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 108,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 127,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 136,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 137,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 144,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 153,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 153,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 153,
      "pins": 76,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:5",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 29,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 70,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 76,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 91,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 98,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 98,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:6",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 49,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 68,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 87,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 105,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 114,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 122,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 130,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 130,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-21:7",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 39,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 85,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 93,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 99,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            8
          ],
          "cumulative": 117,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 117,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:1",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 0,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 70,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 103,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 108,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            5
          ],
          "cumulative": 123,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 123,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:2",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 43,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 91,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 100,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 116,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 116,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:3",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 19,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 31,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 51,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 70,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:4",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 26,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 81,
          "score": 17,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 97,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:5",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 26,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 72,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 81,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 100,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            9,
            "-"
          ],
          "cumulative": 119,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 119,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-06-28:6",
      "date": {
        "year": 2023,
        "month": 6,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 30,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 56,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 74,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 106,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 115,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 134,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 143,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            "X",
            6
          ],
          "cumulative": 169,
          "score": 26,
          "pins": 26,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 169,
      "pins": 110,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 6,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 36,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 55,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 64,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 84,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 113,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 132,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 141,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 150,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 159,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 159,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 45,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 83,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 103,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 121,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 129,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 134,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 24,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 57,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 77,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 96,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 105,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:4",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 50,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 79,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            3
          ],
          "cumulative": 83,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 102,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 111,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 111,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:5",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 14,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 33,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 62,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 81,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 126,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 133,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 133,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:6",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 37,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 54,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 61,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 69,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 78,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 114,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 114,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:7",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 52,
          "score": 24,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 69,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 76,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 85,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 112,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 120,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            8
          ],
          "cumulative": 138,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 138,
      "pins": 100,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-01:8",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 1
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 14,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 33,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 51,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 60,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 114,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 114,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 34,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 49,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 71,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 78,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            "X"
          ],
          "cumulative": 106,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 106,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 52,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 71,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 91,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 106,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 111,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 129,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 129,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 38,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 101,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 110,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 117,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 126,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 126,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:4",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 63,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 90,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 108,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 126,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 134,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            8
          ],
          "cumulative": 152,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 152,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 7,
          "single": 1,
          "multiple": 6
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:5",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 65,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 73,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 96,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 101,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 101,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:6",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 100,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 119,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            3
          ],
          "cumulative": 132,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 132,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.5,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-05:7",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 20,
          "score": 13,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 28,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 53,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 60,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 67,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 95,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "/",
            "X"
          ],
          "cumulative": 115,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 115,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 3,
          "converted": 1
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-11:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 11
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 16,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 23,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 41,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 60,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 70,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 73,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 91,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 99,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 104,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New main ball. Very hard to tame.",
      "score": 104,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 5,
          "single": 1,
          "multiple": 4
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-11:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 11
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 60,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 78,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 93,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 98,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 105,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New main ball. Very hard to tame.",
      "score": 105,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 4,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 10,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 20,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 27,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 54,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 80,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            "-"
          ],
          "cumulative": 119,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 119,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 31,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 39,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 45,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 62,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 82,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 100,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 108,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 108,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 40,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 76,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 84,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 101,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 108,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 108,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:4",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 15,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 28,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 35,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 74,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 94,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 110,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 116,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 124,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 124,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:5",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 29,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 36,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 58,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 61,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 70,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 77,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 77,
      "pins": 74,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-12:6",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 1,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 8,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 42,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 59,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 90,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still learning (hardly) to tame new main ball. Very hard to find my way.",
      "score": 90,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-17:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 17
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 4,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 12,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 21,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 32,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 44,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 70,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 77,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 82,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Dry lane, trying new Turbo switchable thumb system.",
      "score": 82,
      "pins": 73,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-17:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 17
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 11,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 19,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            1
          ],
          "cumulative": 20,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 28,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 51,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 68,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 76,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "Dry lane, trying new Turbo switchable thumb system.",
      "score": 76,
      "pins": 69,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.7,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 9,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-17:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 17
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 48,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 63,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 78,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Dry lane, trying new Turbo switchable thumb system.",
      "score": 95,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 14,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 24,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 24,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 27,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 53,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Taming the new Turbo switchable thumb system. Swollen thumb, had a bit of a bad start.",
      "score": 80,
      "pins": 72,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 4.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 9,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 36,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 86,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 100,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 108,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 117,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 125,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 125,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:4",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 17,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 30,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 57,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            8
          ],
          "cumulative": 112,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 112,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:5",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 66,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 75,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 100,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 120,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 140,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            6
          ],
          "cumulative": 156,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 156,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-19:6",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 54,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 90,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 108,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/",
            4
          ],
          "cumulative": 122,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 122,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:1",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 35,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 43,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 61,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 79,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 106,
          "score": 19,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 115,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 115,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.4,
        "splits": {
          "total": 2,
          "converted": 1
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:2",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 43,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 56,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 65,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 102,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 102,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:3",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 66,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 83,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 90,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 107,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 107,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:4",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 63,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 111,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 129,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 138,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 138,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:5",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 57,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 80,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 105,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 111,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 120,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 120,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-07-26:6",
      "date": {
        "year": 2023,
        "month": 7,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 81,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            7,
            2
          ],
          "cumulative": 118,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 118,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:1",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 76,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 85,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            "-"
          ],
          "cumulative": 112,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 112,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:2",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 15,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 25,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 57,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 82,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:3",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 56,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 65,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 113,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 132,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 132,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 4,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:4",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 28,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 42,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 67,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 85,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 101,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 101,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:5",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 64,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 89,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 105,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 114,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 123,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 123,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:6",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 67,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 85,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 93,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 113,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 131,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 148,
          "score": 17,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 157,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 157,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.8,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 3,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-02:7",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 2
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 19,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 38,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 55,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 71,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 95,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/",
            3
          ],
          "cumulative": 108,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 108,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:1",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 48,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 58,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            "X",
            3
          ],
          "cumulative": 123,
          "score": 23,
          "pins": 23,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 123,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 5,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:2",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 90,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            4,
            5
          ],
          "cumulative": 118,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 118,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:3",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 3,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 12,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 19,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 37,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 54,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 62,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 102,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:4",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 71,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 78,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 97,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 106,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 114,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 114,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:5",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 15,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 24,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 40,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 50,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 53,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 72,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 90,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            4
          ],
          "cumulative": 104,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 104,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-09:6",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 53,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 73,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 101,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            4
          ],
          "cumulative": 105,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 112,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 112,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-16:1",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 16
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 17,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 30,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 75,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 94,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 109,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 109,
      "pins": 80,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-16:2",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 16
      },
      "ball": "14",
      "oilPattern": "Typical House Shot",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 19,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 26,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 64,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 73,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/",
            8
          ],
          "cumulative": 100,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 100,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-16:3",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 16
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 30,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 64,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 71,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            6
          ],
          "cumulative": 104,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "New oil pattern, trying to find my marks.",
      "score": 104,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-16:4",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 16
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 14,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 20,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 67,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 74,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 81,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 88,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 95,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 95,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-16:5",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 16
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 43,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 51,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 65,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 93,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-22:1",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 22
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 14,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 23,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 43,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 96,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 112,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 118,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 127,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 127,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-22:2",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 22
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 16,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 24,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            3
          ],
          "cumulative": 50,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 69,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 78,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 95,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-22:3",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 22
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 46,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 91,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 100,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-22:4",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 22
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 14,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 22,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 31,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 45,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 49,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 68,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 77,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 93,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            3
          ],
          "cumulative": 106,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 106,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-29:1",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 36,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 50,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 63,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 79,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 95,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            7
          ],
          "cumulative": 121,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 121,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-29:2",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 44,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 61,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 68,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 77,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 95,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 103,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 111,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 111,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-29:3",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 25,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 43,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 54,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 62,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 82,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 100,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 108,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 108,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-29:4",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 22,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 41,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 53,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 88,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 108,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            8
          ],
          "cumulative": 126,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 126,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-08-29:5",
      "date": {
        "year": 2023,
        "month": 8,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 13,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 33,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 53,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 68,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 77,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 97,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 116,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 125,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 132,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 132,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-05:1",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 35,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 52,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 59,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 89,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 116,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 136,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 156,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 176,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            3
          ],
          "cumulative": 189,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 189,
      "pins": 100,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 5,
          "single": 0,
          "multiple": 5
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-05:2",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 14,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 41,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 65,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 81,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-05:3",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 44,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 50,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 64,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 92,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 112,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 131,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 140,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 140,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-05:4",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 5
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 55,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 75,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 99,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 119,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 138,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 147,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 147,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-06:1",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 58,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 101,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 101,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-06:2",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 56,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 63,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 77,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 122,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            5
          ],
          "cumulative": 137,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 137,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-06:3",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 35,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 59,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 75,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 95,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 111,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 117,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 117,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:1",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 68,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 84,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 108,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 115,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 133,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 141,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 141,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:2",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 15,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 32,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 39,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 73,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 98,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:3",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 11,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 62,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 69,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 78,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 84,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 92,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:4",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 34,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 54,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 106,
          "score": 24,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 120,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 124,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 132,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 132,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:5",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 63,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 79,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 88,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/",
            9
          ],
          "cumulative": 115,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 115,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:6",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 27,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 43,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 69,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 77,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 96,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 112,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 112,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-12:7",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 24,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 42,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 62,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 80,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 113,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 122,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 122,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:1",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 26,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 81,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 87,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 94,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 112,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            7,
            "/"
          ],
          "cumulative": 132,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 132,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:2",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 35,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 43,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 91,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 109,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 117,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 126,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 126,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:3",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 48,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 68,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 85,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 92,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 108,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 117,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 134,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 154,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X",
            9,
            "/"
          ],
          "cumulative": 174,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 174,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 6,
          "single": 2,
          "multiple": 4
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:4",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 91,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 99,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 108,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 108,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:5",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 84,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 102,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 102,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:6",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 34,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 42,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 49,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 66,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 80,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            "/"
          ],
          "cumulative": 116,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 116,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-19:7",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 20,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 27,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 53,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 88,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 93,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 100,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-20:1",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 20
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 24,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 49,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 66,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 103,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 120,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 127,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 127,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-20:2",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 20
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 24,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 31,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 40,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 64,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 90,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            1
          ],
          "cumulative": 109,
          "score": 11,
          "pins": 11,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 109,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-09-20:3",
      "date": {
        "year": 2023,
        "month": 9,
        "day": 20
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 40,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 58,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 80,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 107,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 124,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 124,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-10:1",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 11,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 20,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 29,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 45,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 51,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 81,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 111,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 134,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            3,
            6
          ],
          "cumulative": 153,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "First games after health issues & recovery",
      "score": 153,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-10:2",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 46,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 90,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 99,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 107,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 125,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 133,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games after health issues & recovery",
      "score": 133,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-10:3",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 44,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 50,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 65,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 82,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 102,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 119,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 126,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "First games after health issues & recovery",
      "score": 126,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-10:4",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 33,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 40,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            2
          ],
          "cumulative": 69,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 76,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 96,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 113,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 120,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "First games after health issues & recovery",
      "score": 120,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-10:5",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 54,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 65,
          "score": 11,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 92,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 101,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 110,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 127,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            "-"
          ],
          "cumulative": 137,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "First games after health issues & recovery",
      "score": 137,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 0,
        "spares": {
          "total": 7,
          "single": 2,
          "multiple": 5
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-11:1",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 11
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 41,
          "score": 25,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 67,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 94,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 121,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 130,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 130,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-11:2",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 11
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 29,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 58,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 86,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 94,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 120,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 128,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 128,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-11:3",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 11
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 19,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 25,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 45,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 61,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 69,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 89,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 107,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 115,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 123,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 123,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-18:1",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 18
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 36,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 52,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 60,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 78,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 105,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 114,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 114,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-18:2",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 18
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 60,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 67,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 85,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 105,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 125,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "/",
            7
          ],
          "cumulative": 142,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 142,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-18:3",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 18
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 54,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 108,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            9
          ],
          "cumulative": 127,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 127,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-10-18:4",
      "date": {
        "year": 2023,
        "month": 10,
        "day": 18
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 25,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 70,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 78,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 84,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 100,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 106,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 106,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-07:1",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 7
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 55,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 63,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 73,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 81,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-07:2",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 7
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 46,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 64,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 72,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 80,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 96,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 104,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 104,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-07:3",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 7
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 33,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 60,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 68,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 83,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 92,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 110,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            9
          ],
          "cumulative": 129,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 129,
      "pins": 102,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 5,
          "single": 1,
          "multiple": 4
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-07:4",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 7
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 65,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 83,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 91,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 91,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 110,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 119,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 119,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:1",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 56,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 63,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 21,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 97,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 100,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 107,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 125,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 134,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:2",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 42,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 59,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 75,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 94,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 110,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            6,
            "-"
          ],
          "cumulative": 126,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 126,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:3",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 69,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 84,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 89,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 96,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 114,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 122,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 127,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 136,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 136,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:4",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 26,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 42,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 71,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 89,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 106,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 125,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 134,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 134,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:5",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 46,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 66,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 83,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 92,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 99,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 108,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 117,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 124,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 124,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-28:6",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 28
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 77,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 96,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 113,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 113,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-29:1",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 12,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 21,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 28,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 43,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 48,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 64,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 70,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 88,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 96,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-29:2",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 56,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 95,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 111,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 117,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 126,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 126,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-11-29:3",
      "date": {
        "year": 2023,
        "month": 11,
        "day": 29
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 45,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 53,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 76,
          "score": 14,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 80,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 100,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X",
            7,
            "/"
          ],
          "cumulative": 120,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 120,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-12:1",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 80,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 89,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            7,
            2
          ],
          "cumulative": 116,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 116,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-12:2",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 11,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 31,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 50,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 78,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 86,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 104,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-12:3",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 20,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 30,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 36,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 54,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 73,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 82,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 89,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 94,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 94,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-13:1",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 48,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 83,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 90,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 109,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 127,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/",
            7
          ],
          "cumulative": 144,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 144,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-13:2",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 27,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 72,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 88,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 96,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 113,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 120,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/",
            7
          ],
          "cumulative": 137,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 137,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-13:3",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            1,
            4
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 12,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 30,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 55,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 63,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 91,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X",
            1,
            7
          ],
          "cumulative": 109,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 109,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-19:1",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 37,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 51,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 68,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 75,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 94,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 112,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            5
          ],
          "cumulative": 127,
          "score": 15,
          "pins": 15,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 127,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-19:2",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 33,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 58,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 84,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 100,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 106,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 115,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 115,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-19:3",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 46,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 55,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 71,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 89,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 117,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 136,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 155,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 155,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-19:4",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 27,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 44,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 51,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 65,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 83,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 91,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 100,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            "-"
          ],
          "cumulative": 118,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 118,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-29:1",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 29
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 0,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 35,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            1
          ],
          "cumulative": 49,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            2,
            1
          ],
          "cumulative": 52,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 58,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 76,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, with the kid, on completely dry lane",
      "score": 76,
      "pins": 67,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-29:2",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 29
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 35,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 57,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 92,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Really casual games, with the kid, on completely dry lane",
      "score": 100,
      "pins": 84,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2023-12-29:3",
      "date": {
        "year": 2023,
        "month": 12,
        "day": 29
      },
      "ball": "14",
      "oilPattern": false,
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 32,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 50,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 75,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 82,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 96,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            8
          ],
          "cumulative": 114,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Really casual games, with the kid, on completely dry lane",
      "score": 114,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-10:1",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 33,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 39,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 58,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 75,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 95,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 113,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 122,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 122,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-10:2",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 44,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 50,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 83,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 89,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            1
          ],
          "cumulative": 108,
          "score": 11,
          "pins": 11,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 108,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-10:3",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 36,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 42,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 80,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 98,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 106,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "F"
          ],
          "cumulative": 114,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 123,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            8
          ],
          "cumulative": 141,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 141,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 1
      }
    },
    {
      "id": "2024-01-25:1",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 25
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 28,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 37,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 44,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 53,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 89,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 98,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            6
          ],
          "cumulative": 114,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 114,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-25:2",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 25
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 73,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 93,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 112,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 121,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 130,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 139,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 148,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 148,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-25:3",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 25
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 34,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 51,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 67,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 85,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 94,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 103,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 121,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            9
          ],
          "cumulative": 140,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 140,
      "pins": 102,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 6,
          "single": 1,
          "multiple": 5
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-30:1",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 30
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 53,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 91,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 110,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 119,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            7
          ],
          "cumulative": 136,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 136,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 2,
          "converted": 1
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-30:2",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 30
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 67,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 87,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 107,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 122,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 131,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 140,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 149,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 149,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 0,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-30:3",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 30
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 48,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 68,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 86,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 111,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 139,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 139,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-01-30:4",
      "date": {
        "year": 2024,
        "month": 1,
        "day": 30
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 50,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 56,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 75,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 102,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 111,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            9
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 130,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-02-06:1",
      "date": {
        "year": 2024,
        "month": 2,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 45,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 70,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 77,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 96,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            8
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 123,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 131,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 131,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-02-06:2",
      "date": {
        "year": 2024,
        "month": 2,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 26,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 45,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            3
          ],
          "cumulative": 66,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 75,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 95,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 115,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            "X"
          ],
          "cumulative": 135,
          "score": 20,
          "pins": 20,
          "split": "converted",
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 135,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.8,
        "splits": {
          "total": 1,
          "converted": 1
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-02-06:3",
      "date": {
        "year": 2024,
        "month": 2,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 61,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 81,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 92,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 112,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 132,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/",
            8
          ],
          "cumulative": 150,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 150,
      "pins": 103,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-02-06:4",
      "date": {
        "year": 2024,
        "month": 2,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 13,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 33,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 59,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 113,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 121,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 128,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 128,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-02-06:5",
      "date": {
        "year": 2024,
        "month": 2,
        "day": 6
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 41,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 61,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 79,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 87,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 94,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 102,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 110,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 110,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-19:1",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 14,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 32,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 40,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 56,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 76,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 86,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 95,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 104,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a few weeks, after a crooked ankle.",
      "score": 104,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-19:2",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 25,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 33,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 48,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 85,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 113,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a few weeks, after a crooked ankle.",
      "score": 113,
      "pins": 86,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-19:3",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 93,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 110,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 129,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 148,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 157,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a few weeks, after a crooked ankle.",
      "score": 157,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-19:4",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 30,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 39,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 85,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 102,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 111,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 149,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "Back to training after a few weeks, after a crooked ankle.",
      "score": 149,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 2,
          "converted": 1
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-19:5",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 19
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 38,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 57,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 86,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 112,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 131,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 140,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 149,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a few weeks, after a crooked ankle.",
      "score": 149,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:1",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 10,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 16,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 23,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 42,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 51,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 58,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 84,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 104,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 123,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 140,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 140,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:2",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 27,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 55,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 73,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 93,
          "score": 20,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 112,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 121,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 141,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/",
            "X"
          ],
          "cumulative": 161,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 161,
      "pins": 106,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 2,
          "converted": 1
        },
        "strikes": 4,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:3",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 27,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 35,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 44,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 70,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 78,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 96,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 104,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 112,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 112,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:4",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 26,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 44,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 52,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 60,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 69,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 78,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 97,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 106,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 114,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 114,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:5",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 34,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 52,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 72,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 90,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 114,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 120,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 120,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-03-26:6",
      "date": {
        "year": 2024,
        "month": 3,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 26,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 33,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 50,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 57,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 73,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 79,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 98,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 107,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            "-"
          ],
          "cumulative": 125,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 125,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 4,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-10:1",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 26,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 52,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 59,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 70,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 71,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 80,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            1,
            2
          ],
          "cumulative": 101,
          "score": 13,
          "pins": 13,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 101,
      "pins": 85,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-10:2",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 38,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 58,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 86,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 97,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 117,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 136,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 145,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 145,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-10:3",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 46,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 61,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 69,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 87,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 95,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 111,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "/",
            9
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 130,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-10:4",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 10
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 26,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 35,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 54,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 74,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 107,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            6,
            "-"
          ],
          "cumulative": 123,
          "score": 16,
          "pins": 16,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 123,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-17:1",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 26,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 34,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 52,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            4
          ],
          "cumulative": 57,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 90,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 90,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-17:2",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 17,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 53,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 62,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 91,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 121,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            "X",
            9
          ],
          "cumulative": 150,
          "score": 29,
          "pins": 29,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 150,
      "pins": 111,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-17:3",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 43,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 51,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 70,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 79,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 99,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 119,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X",
            "X",
            9
          ],
          "cumulative": 148,
          "score": 29,
          "pins": 29,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 148,
      "pins": 111,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 5,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-17:4",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 21,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 40,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 49,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 63,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 80,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 87,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 107,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X",
            1,
            8
          ],
          "cumulative": 126,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 126,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 2,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-17:5",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 17
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 18,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 27,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 43,
          "score": 16,
          "pins": 10,
          "split": "converted",
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 68,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 74,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 94,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            "/"
          ],
          "cumulative": 109,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 114,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 123,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 123,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 2,
          "converted": 1
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-23:1",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 23
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 16,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 33,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 50,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 58,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 66,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 75,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 81,
          "score": 6,
          "pins": 6,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 90,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/",
            "X"
          ],
          "cumulative": 110,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 110,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-23:2",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 23
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 48,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 68,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 87,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 113,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 121,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 128,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            9,
            "/"
          ],
          "cumulative": 148,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 148,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-23:3",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 23
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 15,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 23,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 41,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 49,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 74,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 80,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 88,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            5,
            3
          ],
          "cumulative": 106,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "score": 106,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-04-23:4",
      "date": {
        "year": 2024,
        "month": 4,
        "day": 23
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 16,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 22,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 54,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 63,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 101,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 109,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 118,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 118,
      "pins": 87,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-14:1",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 9,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            3
          ],
          "cumulative": 22,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 40,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 48,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 77,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 84,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "score": 84,
      "pins": 71,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-14:2",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            4,
            "-"
          ],
          "cumulative": 4,
          "score": 4,
          "pins": 4,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 23,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 41,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 49,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "/"
          ],
          "cumulative": 74,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 91,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 111,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 130,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 139,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 139,
      "pins": 90,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 5,
          "single": 2,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-14:3",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 35,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 51,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 57,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 74,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 97,
          "score": 15,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 112,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 129,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "score": 129,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-14:4",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 14
      },
      "ball": "14",
      "oilPattern": "Ratio 5 / 43ft",
      "frames": [
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 25,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 39,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 48,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 64,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 77,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            4
          ],
          "cumulative": 84,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            9
          ],
          "cumulative": 103,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "score": 103,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-21:1",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Ratio 3 / 42ft",
      "frames": [
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 26,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 46,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 26,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 110,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 128,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 136,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 145,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 154,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, new urethane ball",
      "score": 154,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-21:2",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Ratio 3 / 42ft",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 36,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 63,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 71,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "-"
          ],
          "cumulative": 74,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 92,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 117,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "New oil pattern, new urethane ball",
      "score": 117,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.8,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-05-21:3",
      "date": {
        "year": 2024,
        "month": 5,
        "day": 21
      },
      "ball": "14",
      "oilPattern": "Ratio 3 / 42ft",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 14,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 20,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 27,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 36,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 45,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            4
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 61,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            "-"
          ],
          "cumulative": 62,
          "score": 1,
          "pins": 1,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 71,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Slight left leg pain",
      "score": 71,
      "pins": 71,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 8,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-12:1",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 30,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 38,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 45,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 61,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 68,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 75,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 98,
          "score": 23,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            3,
            "/"
          ],
          "cumulative": 118,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "New oil pattern, challenging to find my spot",
      "score": 118,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.3,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-12:2",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 17,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 24,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 49,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 55,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 73,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 81,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "-"
          ],
          "cumulative": 81,
          "score": 0,
          "pins": 0,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 100,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, challenging to find my spot",
      "score": 109,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-12:3",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 34,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 41,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 48,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 57,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 65,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 71,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            2
          ],
          "cumulative": 77,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, challenging to find my spot",
      "score": 85,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 5.2,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-12:4",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 14,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            3
          ],
          "cumulative": 21,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            3
          ],
          "cumulative": 29,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 37,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 44,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 28,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 90,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 98,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 107,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, challenging to find my spot",
      "score": 107,
      "pins": 81,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-12:5",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 24,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 33,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 42,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 59,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 66,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 75,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 84,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 93,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            "X"
          ],
          "cumulative": 113,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "New oil pattern, challenging to find my spot",
      "score": 113,
      "pins": 97,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 7,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:1",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 28,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 83,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            6
          ],
          "cumulative": 89,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 97,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 105,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/",
            "X"
          ],
          "cumulative": 125,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 125,
      "pins": 98,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:2",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 29,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 47,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 55,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 74,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 101,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 109,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 126,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 135,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 135,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 4,
          "single": 1,
          "multiple": 3
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:3",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 65,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 73,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            "/"
          ],
          "cumulative": 92,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 108,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 114,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 123,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 140,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 140,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 6,
          "single": 5,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:4",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 37,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 45,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 54,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 74,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 94,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 114,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 143,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 162,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 171,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 171,
      "pins": 96,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 9,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:5",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 22,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 32,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 50,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 59,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 87,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 96,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 105,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 105,
      "pins": 93,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.1,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-06-26:6",
      "date": {
        "year": 2024,
        "month": 6,
        "day": 26
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 39,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 58,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 67,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 84,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 109,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 116,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            8,
            "-"
          ],
          "cumulative": 134,
          "score": 18,
          "pins": 18,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "New oil pattern, next year league pattern",
      "score": 134,
      "pins": 99,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-07-09:1",
      "date": {
        "year": 2024,
        "month": 7,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            1,
            6
          ],
          "cumulative": 7,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 13,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 21,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 30,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 49,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 58,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 78,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 98,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 128,
          "score": 30,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X",
            "X",
            "X"
          ],
          "cumulative": 158,
          "score": 30,
          "pins": 30,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "Still need to tame this pattern",
      "score": 158,
      "pins": 109,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 5,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-07-09:2",
      "date": {
        "year": 2024,
        "month": 7,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 47,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 53,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 69,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "/"
          ],
          "cumulative": 86,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 102,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            2
          ],
          "cumulative": 110,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 118,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X",
            9,
            "-"
          ],
          "cumulative": 137,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": false,
          "open": false
        }
      ],
      "note": "Still need to tame this pattern",
      "score": 137,
      "pins": 100,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 4,
          "single": 0,
          "multiple": 4
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-07-09:3",
      "date": {
        "year": 2024,
        "month": 7,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 14,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 21,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 37,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            6,
            "-"
          ],
          "cumulative": 43,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 49,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 57,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 77,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 90,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            3,
            3
          ],
          "cumulative": 96,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still need to tame this pattern",
      "score": 96,
      "pins": 77,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 0,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-07-09:4",
      "date": {
        "year": 2024,
        "month": 7,
        "day": 9
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 8,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            4
          ],
          "cumulative": 16,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 25,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 32,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 41,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 54,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 57,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 66,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 82,
          "score": 16,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            5,
            1
          ],
          "cumulative": 88,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Still need to tame this pattern",
      "score": 88,
      "pins": 79,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 0,
          "single": 0,
          "multiple": 0
        },
        "misses": 1,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:1",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            1,
            5
          ],
          "cumulative": 6,
          "score": 6,
          "pins": 6,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 15,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 24,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 43,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 52,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 59,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 66,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            5
          ],
          "cumulative": 74,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 81,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            "X"
          ],
          "cumulative": 101,
          "score": 20,
          "pins": 20,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 101,
      "pins": 92,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:2",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 64,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 83,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 92,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            5,
            2
          ],
          "cumulative": 99,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 108,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/",
            4
          ],
          "cumulative": 122,
          "score": 14,
          "pins": 14,
          "split": false,
          "spare": "multiple",
          "open": false
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 122,
      "pins": 95,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:3",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            "/"
          ],
          "cumulative": 35,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 42,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 60,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 68,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 77,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 103,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 111,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 111,
      "pins": 88,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 3,
          "single": 0,
          "multiple": 3
        },
        "misses": 6,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:4",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 38,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 46,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 65,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 120,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 139,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 148,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 148,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.9,
        "splits": {
          "total": 2,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:5",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 40,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 60,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 78,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 87,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 107,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 125,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 133,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 142,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/",
            9
          ],
          "cumulative": 161,
          "score": 19,
          "pins": 19,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 161,
      "pins": 105,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 9,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 4,
          "single": 3,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-08-13:6",
      "date": {
        "year": 2024,
        "month": 8,
        "day": 13
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 19,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 28,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 47,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 56,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            4,
            5
          ],
          "cumulative": 65,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 74,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 82,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 102,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 119,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 126,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "Back to training after a lot of pro work",
      "score": 126,
      "pins": 91,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.2,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 2,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-12:1",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            1
          ],
          "cumulative": 16,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 36,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            8,
            "/"
          ],
          "cumulative": 55,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 64,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 93,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 112,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 121,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 140,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            9,
            "/",
            7
          ],
          "cumulative": 157,
          "score": 17,
          "pins": 17,
          "split": false,
          "spare": "single",
          "open": false
        }
      ],
      "note": "Fist match of the new league season",
      "score": 157,
      "pins": 101,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.6,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 2,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-12:2",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            "X"
          ],
          "cumulative": 20,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 40,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 60,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 80,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 109,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 128,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 137,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 146,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 154,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 162,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Fist match of the new league season",
      "score": 162,
      "pins": 94,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 8.8,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 4,
        "spares": {
          "total": 2,
          "single": 1,
          "multiple": 1
        },
        "misses": 2,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-12:3",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 12
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 36,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 44,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 62,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            1,
            7
          ],
          "cumulative": 70,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 81,
          "score": 11,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            1,
            2
          ],
          "cumulative": 84,
          "score": 3,
          "pins": 3,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 92,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 100,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "Fist match of the new league season",
      "score": 100,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.9,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 1,
        "spares": {
          "total": 2,
          "single": 2,
          "multiple": 0
        },
        "misses": 3,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-24:1",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Stone Street",
      "frames": [
        {
          "outcome": [
            5,
            "-"
          ],
          "cumulative": 5,
          "score": 5,
          "pins": 5,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 25,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 35,
          "score": 10,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 43,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 72,
          "score": 29,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            "X"
          ],
          "cumulative": 92,
          "score": 20,
          "pins": 10,
          "split": false,
          "spare": false,
          "open": false
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 109,
          "score": 17,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            7,
            "/"
          ],
          "cumulative": 127,
          "score": 18,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 135,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            "-"
          ],
          "cumulative": 143,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "score": 143,
      "pins": 89,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 7.4,
        "splits": {
          "total": 1,
          "converted": 0
        },
        "strikes": 3,
        "spares": {
          "total": 3,
          "single": 1,
          "multiple": 2
        },
        "misses": 4,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-24:2",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "42\"",
      "frames": [
        {
          "outcome": [
            "-",
            9
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            8
          ],
          "cumulative": 17,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 25,
          "score": 8,
          "pins": 8,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 30,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 39,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            7
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            6,
            3
          ],
          "cumulative": 55,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            3,
            "/"
          ],
          "cumulative": 74,
          "score": 19,
          "pins": 10,
          "split": false,
          "spare": "multiple",
          "open": false
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 83,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            8,
            1
          ],
          "cumulative": 92,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        }
      ],
      "note": "I'm really bad at adapting to never-saw oiling patterns",
      "score": 92,
      "pins": 83,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 3.6,
        "splits": {
          "total": 0,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 0,
          "multiple": 1
        },
        "misses": 5,
        "fouls": 0
      }
    },
    {
      "id": "2024-09-24:3",
      "date": {
        "year": 2024,
        "month": 9,
        "day": 24
      },
      "ball": "14",
      "oilPattern": "Bourbon",
      "frames": [
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 9,
          "score": 9,
          "pins": 9,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            2
          ],
          "cumulative": 18,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 25,
          "score": 7,
          "pins": 7,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 34,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            "-",
            5
          ],
          "cumulative": 39,
          "score": 5,
          "pins": 5,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            "-"
          ],
          "cumulative": 46,
          "score": 7,
          "pins": 7,
          "split": "yes",
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "/"
          ],
          "cumulative": 59,
          "score": 13,
          "pins": 10,
          "split": false,
          "spare": "single",
          "open": false
        },
        {
          "outcome": [
            3,
            6
          ],
          "cumulative": 68,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            9,
            "-"
          ],
          "cumulative": 77,
          "score": 9,
          "pins": 9,
          "split": false,
          "spare": false,
          "open": true
        },
        {
          "outcome": [
            7,
            1
          ],
          "cumulative": 85,
          "score": 8,
          "pins": 8,
          "split": "yes",
          "spare": false,
          "open": true
        }
      ],
      "note": "Yep, really bad at adapting to oiling patterns",
      "score": 85,
      "pins": 82,
      "perfect": false,
      "stats": {
        "avgFirstBallPinfall": 6.5,
        "splits": {
          "total": 3,
          "converted": 0
        },
        "strikes": 0,
        "spares": {
          "total": 1,
          "single": 1,
          "multiple": 0
        },
        "misses": 5,
        "fouls": 0
      }
    }
  ],
  "leagues": [
    {
      "name": "ILB Trio League 2024-2025",
      "days": [
        {
          "dayIndex": 2,
          "date": {
            "year": 2024,
            "month": 9,
            "day": 12
          },
          "bye": false,
          "team": "2B1P",
          "vs": "Terrassements Charlier",
          "avg": 123,
          "handicap": 87,
          "oilPatterns": [
            "Stone Street",
            "Stone Street"
          ],
          "games": [
            {
              "id": "2024-09-12:1",
              "date": {
                "year": 2024,
                "month": 9,
                "day": 12
              },
              "ball": "14",
              "oilPattern": "Stone Street",
              "frames": [
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    1
                  ],
                  "cumulative": 16,
                  "score": 7,
                  "pins": 7,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 36,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "/"
                  ],
                  "cumulative": 55,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 64,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 93,
                  "score": 29,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 112,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 121,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 140,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/",
                    7
                  ],
                  "cumulative": 157,
                  "score": 17,
                  "pins": 17,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "note": "Fist match of the new league season",
              "score": 244,
              "pins": 101,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.6,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 3,
                  "single": 2,
                  "multiple": 1
                },
                "misses": 2,
                "fouls": 0
              },
              "handicap": 87,
              "scratch": 157
            },
            {
              "id": "2024-09-12:2",
              "date": {
                "year": 2024,
                "month": 9,
                "day": 12
              },
              "ball": "14",
              "oilPattern": "Stone Street",
              "frames": [
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 20,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 40,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 60,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 80,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 109,
                  "score": 29,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 128,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 137,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 146,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    1
                  ],
                  "cumulative": 154,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 162,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "note": "Fist match of the new league season",
              "score": 249,
              "pins": 94,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.8,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 4,
                "spares": {
                  "total": 2,
                  "single": 1,
                  "multiple": 1
                },
                "misses": 2,
                "fouls": 0
              },
              "handicap": 87,
              "scratch": 162
            },
            {
              "id": "2024-09-12:3",
              "date": {
                "year": 2024,
                "month": 9,
                "day": 12
              },
              "ball": "14",
              "oilPattern": "Stone Street",
              "frames": [
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 18,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 36,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 44,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 62,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    1,
                    7
                  ],
                  "cumulative": 70,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 81,
                  "score": 11,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    1,
                    2
                  ],
                  "cumulative": 84,
                  "score": 3,
                  "pins": 3,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 92,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 100,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "note": "Fist match of the new league season",
              "score": 187,
              "pins": 83,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 6.9,
                "splits": {
                  "total": 3,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 2,
                  "single": 2,
                  "multiple": 0
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 87,
              "scratch": 100
            }
          ]
        }
      ]
    },
    {
      "name": "ILB Trio League 2023-2024",
      "days": [
        {
          "dayIndex": 1,
          "date": {
            "year": 2023,
            "month": 9,
            "day": 6
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "Plastidor",
          "avg": 160,
          "handicap": 40,
          "note": "Avg is fixed to 160 as it's my first league participation.",
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2023-09-06:1",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 6
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 17,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 25,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "-",
                    7
                  ],
                  "cumulative": 32,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    5,
                    3
                  ],
                  "cumulative": 40,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 58,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 66,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 84,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 92,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 101,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 141,
              "pins": 85,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.1,
                "splits": {
                  "total": 3,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 1,
                  "single": 1,
                  "multiple": 0
                },
                "misses": 5,
                "fouls": 0
              },
              "handicap": 40,
              "scratch": 101
            },
            {
              "id": "2023-09-06:2",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 6
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    5,
                    "/"
                  ],
                  "cumulative": 19,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 39,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 56,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 63,
                  "score": 7,
                  "pins": 7,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 77,
                  "score": 14,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    4,
                    4
                  ],
                  "cumulative": 85,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 94,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 102,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 122,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/",
                    5
                  ],
                  "cumulative": 137,
                  "score": 15,
                  "pins": 15,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                }
              ],
              "score": 177,
              "pins": 97,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.4,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 4,
                  "single": 1,
                  "multiple": 3
                },
                "misses": 2,
                "fouls": 0
              },
              "handicap": 40,
              "scratch": 137
            },
            {
              "id": "2023-09-06:3",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 6
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 7,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 16,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 35,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 44,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    5,
                    3
                  ],
                  "cumulative": 52,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "-",
                    7
                  ],
                  "cumulative": 59,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 75,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 95,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 111,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "-",
                    6
                  ],
                  "cumulative": 117,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 157,
              "pins": 86,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 6.2,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 2,
                  "single": 0,
                  "multiple": 2
                },
                "misses": 5,
                "fouls": 0
              },
              "handicap": 40,
              "scratch": 117
            }
          ]
        },
        {
          "dayIndex": 2,
          "date": {
            "year": 2023,
            "month": 9,
            "day": 13
          },
          "bye": true,
          "team": "The Barlos",
          "vs": "Atelier du charpentier",
          "note": "Player rotation, didn't play that match.",
          "games": []
        },
        {
          "dayIndex": 3,
          "date": {
            "year": 2023,
            "month": 9,
            "day": 20
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "Lambdas",
          "avg": 150.4,
          "handicap": 59,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2023-09-20:1",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 20
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 18,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 24,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 32,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 49,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 66,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 83,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 103,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 120,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 127,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 186,
              "pins": 89,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.1,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 4,
                  "single": 0,
                  "multiple": 4
                },
                "misses": 2,
                "fouls": 0
              },
              "handicap": 59,
              "scratch": 127
            },
            {
              "id": "2023-09-20:2",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 20
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 7,
                  "score": 7,
                  "pins": 7,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 24,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    1
                  ],
                  "cumulative": 31,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 40,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 48,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 64,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 72,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 90,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    3,
                    5
                  ],
                  "cumulative": 98,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/",
                    1
                  ],
                  "cumulative": 109,
                  "score": 11,
                  "pins": 11,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "score": 168,
              "pins": 88,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.5,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 2,
                  "single": 1,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 59,
              "scratch": 109
            },
            {
              "id": "2023-09-20:3",
              "date": {
                "year": 2023,
                "month": 9,
                "day": 20
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    "-",
                    "/"
                  ],
                  "cumulative": 20,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 40,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 58,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 67,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 75,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    5,
                    "-"
                  ],
                  "cumulative": 80,
                  "score": 5,
                  "pins": 5,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 89,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 98,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 107,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/",
                    7
                  ],
                  "cumulative": 124,
                  "score": 17,
                  "pins": 17,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "score": 183,
              "pins": 96,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 6.8,
                "splits": {
                  "total": 2,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 3,
                  "single": 2,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 59,
              "scratch": 124
            }
          ]
        },
        {
          "dayIndex": 3,
          "date": {
            "year": 2023,
            "month": 9,
            "day": 27
          },
          "bye": true,
          "team": "The Barlos",
          "vs": "Le Beau Vivier",
          "note": "Player rotation, didn't play that match.",
          "games": []
        },
        {
          "dayIndex": 4,
          "date": {
            "year": 2023,
            "month": 10,
            "day": 4
          },
          "bye": true,
          "team": "The Barlos",
          "vs": "Terrassements Charlier",
          "note": "Health issue, on recovery.",
          "games": []
        },
        {
          "dayIndex": 5,
          "date": {
            "year": 2023,
            "month": 10,
            "day": 11
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "C. Sauvage infirmière",
          "avg": 144.7,
          "handicap": 65,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2023-10-11:1",
              "date": {
                "year": 2023,
                "month": 10,
                "day": 11
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 16,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 41,
                  "score": 25,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 59,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    5,
                    3
                  ],
                  "cumulative": 67,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 76,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 94,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 102,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 121,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 130,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 195,
              "pins": 90,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.1,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 1,
                  "single": 0,
                  "multiple": 1
                },
                "misses": 4,
                "fouls": 0
              },
              "handicap": 65,
              "scratch": 130
            },
            {
              "id": "2023-10-11:2",
              "date": {
                "year": 2023,
                "month": 10,
                "day": 11
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 17,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 24,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "-",
                    5
                  ],
                  "cumulative": 29,
                  "score": 5,
                  "pins": 5,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 58,
                  "score": 29,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 77,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 86,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 94,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 102,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 120,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 128,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 193,
              "pins": 85,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.6,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 1,
                  "single": 0,
                  "multiple": 1
                },
                "misses": 6,
                "fouls": 0
              },
              "handicap": 65,
              "scratch": 128
            },
            {
              "id": "2023-10-11:3",
              "date": {
                "year": 2023,
                "month": 10,
                "day": 11
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 8,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "/"
                  ],
                  "cumulative": 19,
                  "score": 11,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    1,
                    5
                  ],
                  "cumulative": 25,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 45,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 61,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 69,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 89,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 107,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "-",
                    8
                  ],
                  "cumulative": 115,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 123,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 188,
              "pins": 88,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 2,
                  "single": 1,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 65,
              "scratch": 123
            }
          ]
        },
        {
          "dayIndex": 11,
          "date": {
            "year": 2023,
            "month": 11,
            "day": 29
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "Atelier du Charpentier",
          "avg": 141.9,
          "handicap": 68,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2023-11-29:1",
              "date": {
                "year": 2023,
                "month": 11,
                "day": 29
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    4,
                    2
                  ],
                  "cumulative": 6,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    3
                  ],
                  "cumulative": 12,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 21,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    4
                  ],
                  "cumulative": 28,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 43,
                  "score": 15,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "-",
                    5
                  ],
                  "cumulative": 48,
                  "score": 5,
                  "pins": 5,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    "/"
                  ],
                  "cumulative": 64,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 70,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 88,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 96,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                }
              ],
              "score": 164,
              "pins": 77,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 5.6,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 1,
                  "single": 0,
                  "multiple": 1
                },
                "misses": 4,
                "fouls": 0
              },
              "handicap": 68,
              "scratch": 96
            },
            {
              "id": "2023-11-29:2",
              "date": {
                "year": 2023,
                "month": 11,
                "day": 29
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 18,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 27,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 36,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 56,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 76,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 95,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 111,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 117,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 126,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 194,
              "pins": 91,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.1,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 3,
                  "single": 2,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 68,
              "scratch": 126
            },
            {
              "id": "2023-11-29:3",
              "date": {
                "year": 2023,
                "month": 11,
                "day": 29
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 18,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 27,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 45,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 53,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 62,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 76,
                  "score": 14,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    4,
                    "-"
                  ],
                  "cumulative": 80,
                  "score": 4,
                  "pins": 4,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 100,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    "X",
                    7,
                    "/"
                  ],
                  "cumulative": 120,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                }
              ],
              "score": 188,
              "pins": 88,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.2,
                "splits": {
                  "total": 2,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 3,
                  "single": 2,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 68,
              "scratch": 120
            }
          ]
        },
        {
          "dayIndex": 13,
          "date": {
            "year": 2023,
            "month": 12,
            "day": 13
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "Le Beau Vivier",
          "avg": 136.8,
          "handicap": 73,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2023-12-13:1",
              "date": {
                "year": 2023,
                "month": 12,
                "day": 13
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 29,
                  "score": 29,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 48,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 57,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 75,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 83,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 90,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 109,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 118,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 127,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    "/",
                    7
                  ],
                  "cumulative": 144,
                  "score": 17,
                  "pins": 17,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                }
              ],
              "score": 217,
              "pins": 99,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.3,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 2,
                  "single": 0,
                  "multiple": 2
                },
                "misses": 4,
                "fouls": 0
              },
              "handicap": 73,
              "scratch": 144
            },
            {
              "id": "2023-12-13:2",
              "date": {
                "year": 2023,
                "month": 12,
                "day": 13
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    1
                  ],
                  "cumulative": 17,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 44,
                  "score": 27,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 63,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 72,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    "/"
                  ],
                  "cumulative": 88,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 96,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 113,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 120,
                  "score": 7,
                  "pins": 7,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    5,
                    "/",
                    7
                  ],
                  "cumulative": 137,
                  "score": 17,
                  "pins": 17,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                }
              ],
              "score": 210,
              "pins": 98,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.1,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 2,
                  "single": 0,
                  "multiple": 2
                },
                "misses": 1,
                "fouls": 0
              },
              "handicap": 73,
              "scratch": 137
            },
            {
              "id": "2023-12-13:3",
              "date": {
                "year": 2023,
                "month": 12,
                "day": 13
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    1,
                    4
                  ],
                  "cumulative": 5,
                  "score": 5,
                  "pins": 5,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    1,
                    6
                  ],
                  "cumulative": 12,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 30,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 38,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 47,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    1
                  ],
                  "cumulative": 55,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    1
                  ],
                  "cumulative": 63,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    2
                  ],
                  "cumulative": 71,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "-",
                    "/"
                  ],
                  "cumulative": 91,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X",
                    1,
                    7
                  ],
                  "cumulative": 109,
                  "score": 18,
                  "pins": 18,
                  "split": false,
                  "spare": false,
                  "open": false
                }
              ],
              "score": 182,
              "pins": 91,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 5.9,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 1,
                  "single": 0,
                  "multiple": 1
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 73,
              "scratch": 109
            }
          ]
        },
        {
          "dayIndex": 15,
          "date": {
            "year": 2024,
            "month": 1,
            "day": 10
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "C. Sauvage infirmière",
          "avg": 136.8,
          "handicap": 73,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2024-01-10:1",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 10
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 8,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    5,
                    4
                  ],
                  "cumulative": 17,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 33,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 39,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 58,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 67,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    1
                  ],
                  "cumulative": 75,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 95,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 113,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 122,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 195,
              "pins": 89,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 7.7,
                "splits": {
                  "total": 0,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 2,
                  "single": 0,
                  "multiple": 2
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 73,
              "scratch": 122
            },
            {
              "id": "2024-01-10:2",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 10
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 8,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "/"
                  ],
                  "cumulative": 28,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 44,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 50,
                  "score": 6,
                  "pins": 6,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    5
                  ],
                  "cumulative": 58,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 67,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    3,
                    "/"
                  ],
                  "cumulative": 83,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 89,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    4,
                    4
                  ],
                  "cumulative": 97,
                  "score": 8,
                  "pins": 8,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/",
                    1
                  ],
                  "cumulative": 108,
                  "score": 11,
                  "pins": 11,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "score": 181,
              "pins": 86,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 6.3,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 3,
                  "single": 1,
                  "multiple": 2
                },
                "misses": 3,
                "fouls": 0
              },
              "handicap": 73,
              "scratch": 108
            },
            {
              "id": "2024-01-10:3",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 10
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 20,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 36,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 42,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 62,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 80,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "/"
                  ],
                  "cumulative": 98,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 106,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "F"
                  ],
                  "cumulative": 114,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 123,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/",
                    8
                  ],
                  "cumulative": 141,
                  "score": 18,
                  "pins": 18,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "score": 214,
              "pins": 99,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.1,
                "splits": {
                  "total": 3,
                  "converted": 0
                },
                "strikes": 2,
                "spares": {
                  "total": 4,
                  "single": 2,
                  "multiple": 2
                },
                "misses": 2,
                "fouls": 1
              },
              "handicap": 73,
              "scratch": 141
            }
          ]
        },
        {
          "dayIndex": 17,
          "date": {
            "year": 2024,
            "month": 1,
            "day": 25
          },
          "bye": false,
          "team": "The Barlos",
          "vs": "Lessimat",
          "avg": 135.4,
          "handicap": 74,
          "oilPatterns": [
            "Ratio 5 / 43ft",
            "Ratio 5 / 43ft"
          ],
          "games": [
            {
              "id": "2024-01-25:1",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 25
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    4,
                    5
                  ],
                  "cumulative": 9,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 28,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 37,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    "-"
                  ],
                  "cumulative": 44,
                  "score": 7,
                  "pins": 7,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 53,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    6,
                    3
                  ],
                  "cumulative": 62,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 71,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 89,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 98,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "/",
                    6
                  ],
                  "cumulative": 114,
                  "score": 16,
                  "pins": 16,
                  "split": false,
                  "spare": "single",
                  "open": false
                }
              ],
              "score": 188,
              "pins": 97,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 1,
                "spares": {
                  "total": 2,
                  "single": 2,
                  "multiple": 0
                },
                "misses": 4,
                "fouls": 0
              },
              "handicap": 74,
              "scratch": 114
            },
            {
              "id": "2024-01-25:2",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 25
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    8,
                    "-"
                  ],
                  "cumulative": 8,
                  "score": 8,
                  "pins": 8,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 17,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 47,
                  "score": 30,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 73,
                  "score": 26,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    "X"
                  ],
                  "cumulative": 93,
                  "score": 20,
                  "pins": 10,
                  "split": false,
                  "spare": false,
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 112,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 121,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 130,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 139,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    9,
                    "-"
                  ],
                  "cumulative": 148,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                }
              ],
              "score": 222,
              "pins": 93,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 8.9,
                "splits": {
                  "total": 1,
                  "converted": 0
                },
                "strikes": 3,
                "spares": {
                  "total": 1,
                  "single": 0,
                  "multiple": 1
                },
                "misses": 6,
                "fouls": 0
              },
              "handicap": 74,
              "scratch": 148
            },
            {
              "id": "2024-01-25:3",
              "date": {
                "year": 2024,
                "month": 1,
                "day": 25
              },
              "ball": "14",
              "oilPattern": "Ratio 5 / 43ft",
              "frames": [
                {
                  "outcome": [
                    6,
                    "-"
                  ],
                  "cumulative": 6,
                  "score": 6,
                  "pins": 6,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 15,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    1,
                    "/"
                  ],
                  "cumulative": 34,
                  "score": 19,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    9,
                    "/"
                  ],
                  "cumulative": 51,
                  "score": 17,
                  "pins": 10,
                  "split": false,
                  "spare": "single",
                  "open": false
                },
                {
                  "outcome": [
                    7,
                    "/"
                  ],
                  "cumulative": 67,
                  "score": 16,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    6,
                    "/"
                  ],
                  "cumulative": 85,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    1
                  ],
                  "cumulative": 94,
                  "score": 9,
                  "pins": 9,
                  "split": "yes",
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    7,
                    2
                  ],
                  "cumulative": 103,
                  "score": 9,
                  "pins": 9,
                  "split": false,
                  "spare": false,
                  "open": true
                },
                {
                  "outcome": [
                    8,
                    "/"
                  ],
                  "cumulative": 121,
                  "score": 18,
                  "pins": 10,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                },
                {
                  "outcome": [
                    8,
                    "/",
                    9
                  ],
                  "cumulative": 140,
                  "score": 19,
                  "pins": 19,
                  "split": false,
                  "spare": "multiple",
                  "open": false
                }
              ],
              "score": 214,
              "pins": 102,
              "perfect": false,
              "stats": {
                "avgFirstBallPinfall": 6.8,
                "splits": {
                  "total": 2,
                  "converted": 0
                },
                "strikes": 0,
                "spares": {
                  "total": 6,
                  "single": 1,
                  "multiple": 5
                },
                "misses": 1,
                "fouls": 0
              },
              "handicap": 74,
              "scratch": 140
            }
          ]
        }
      ]
    }
  ]
}